export const directions = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left'
};



/** WEBPACK FOOTER **
 ** ./js/components/ToolTip/helper/constants.js
 **/